module.exports = __webpack_public_path__ + "img/tip-middle.204cf846.png";